<template>
  <div class="counter">
    <div class="counter__number">
      {{ number }}
    </div>
    <div class="counter__name">
      {{ name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CounterItem",
  props: ["number", "name"],
  data() {
    return {
      title: "counter",
    };
  },
};
</script>
